/**
 * Contribution roles taxonomy.
 *
 * Source: westbury-functions-mono/model_deployment/role_standardisation/
 *         dedup_role_instrument_list.csv (deduplicated upstream).
 *
 * Regenerate: node admin_portal/src/data/generate-contributions-taxonomy.js
 */

/** All unique contribution roles, sorted alphabetically (deduplicated upstream). */
export const allContributionRoles: string[] = [
  "12-string acoustic guitar",
  "12-string bass",
  "12-string guitar",
  "17-string bass koto",
  "4-string banjo",
  "5-string banjo",
  "6-string banjo",
  "6-string bass",
  "8-string bass guitar",
  "accompanist",
  "accordina",
  "accordion",
  "achere",
  "acoustic bass",
  "acoustic bass guitar",
  "acoustic fretless guitar",
  "acoustic guitar",
  "acoustic piano",
  "acoustic piccolo bass",
  "actor",
  "adufe",
  "adungu",
  "aeolian harp",
  "afoxe",
  "african congo drums",
  "afuche",
  "agogo",
  "ajaeng",
  "akete",
  "akkordolia",
  "alfaia",
  "algaita",
  "algerian mandole",
  "alghoza",
  "alphorn",
  "alto",
  "alto clarinet",
  "alto crumhorn",
  "alto flute",
  "alto horn",
  "alto recorder",
  "alto saxophone",
  "alto trombone",
  "alto valve trombone",
  "alto viol",
  "alto violin",
  "alto vocals",
  "amadinda",
  "aman khuur",
  "ambtara",
  "analog synthesizer",
  "anandalahari",
  "anatara",
  "andean flute",
  "andean harp",
  "angklung",
  "anglo-concertina",
  "animal sounds",
  "animal sounds impersonator",
  "ankle rattlers",
  "announcer",
  "antara",
  "anvil",
  "apentemma",
  "apito",
  "apongalahy",
  "appalachian dulcimer",
  "archlute",
  "archtop guitar",
  "arco bass",
  "arghul",
  "arpa",
  "arpeggione",
  "arrabel",
  "artistic narrator",
  "artistic producer",
  "ashiko",
  "associate producer",
  "atabal",
  "atabaque",
  "atarigane",
  "atchere",
  "audio generator",
  "autoharp",
  "automatic orchestra",
  "baandu",
  "baby grand piano",
  "background studio singer",
  "backing band",
  "backing vocals",
  "baglama",
  "baglama (saz) family",
  "bagpipes",
  "bahian guitar",
  "bajo",
  "bajo quinto",
  "bajo sexto",
  "balafon",
  "balalaika",
  "baltic psalteries",
  "bambaro",
  "bamboo flute",
  "band",
  "bandola",
  "bandolin",
  "bandoneon",
  "bandora",
  "bandura",
  "bandurria",
  "bangu",
  "banhu",
  "banjitar",
  "banjo",
  "banjo guitar",
  "banjo-dulcimer",
  "banjo-mandolin",
  "banjo-ukulele",
  "banjolin",
  "banjulele",
  "bankia",
  "bansuri",
  "bapang",
  "bara",
  "barbat",
  "baritone",
  "baritone clarinet",
  "baritone guitar",
  "baritone horn",
  "baritone saxhorn",
  "baritone saxophone",
  "baritone violin",
  "baritone vocals",
  "baroque guitar",
  "baroque trumpet",
  "barrel drum",
  "barrel organ",
  "barrel piano",
  "baryton",
  "bass",
  "bass accordion",
  "bass clarinet",
  "bass concertina",
  "bass crumhorn",
  "bass drum",
  "bass dulcian",
  "bass fado viola",
  "bass flute",
  "bass guitar",
  "bass harmonica",
  "bass lute",
  "bass marimba",
  "bass oboe",
  "bass pedals",
  "bass rackett",
  "bass recorder",
  "bass saxophone",
  "bass synthesizer",
  "bass tambura",
  "bass trombone",
  "bass trumpet",
  "bass tuba",
  "bass viol",
  "bass violin",
  "bass vocals",
  "bass-baritone",
  "bass-baritone vocals",
  "basset clarinet",
  "basset horn",
  "basso continuo",
  "bassoon",
  "basy",
  "bata",
  "bata drum",
  "bawu",
  "bayan",
  "bazooka",
  "beatbox",
  "beats",
  "bedug",
  "bell plate",
  "bell tree",
  "bell-piano",
  "bellow-blown bagpipes",
  "bellowed reed",
  "bellowphone",
  "bells",
  "bembe",
  "bendir",
  "berda",
  "berimbau",
  "bhapang",
  "bicycle bell",
  "big drum",
  "bin",
  "bin-sasara",
  "bin-sitar",
  "biniou",
  "birbyne",
  "birch lur",
  "bisernica",
  "biwa",
  "blaster beam",
  "blues harp",
  "bo (bell)",
  "bo (cymbals)",
  "bo (flute)",
  "boatswain's pipe",
  "bodhran",
  "body percussion",
  "bolivian flute",
  "bolon",
  "bombarde",
  "bombardon",
  "bombo",
  "bombo (bass drum)",
  "bombo (frame drum)",
  "bombo (mouth bom)",
  "bombo leguero",
  "bonang",
  "bonang barung",
  "bonang panembung",
  "bonang panerus",
  "bones",
  "bongos",
  "boobam",
  "boomwhacker",
  "border pipes",
  "bordonua",
  "bottle",
  "bouzar",
  "bouzouki",
  "bowed lute",
  "bowed lyre",
  "bowed piano",
  "bowed psaltery",
  "bowed string instruments",
  "box zither",
  "brac",
  "braguinha",
  "brass",
  "brass band",
  "brass bass",
  "bronze lur",
  "broom",
  "brushes",
  "bucium",
  "bugarija",
  "bugle",
  "buhay",
  "buisine",
  "buk",
  "bukkehorn",
  "bulbul tarang",
  "bull fiddle",
  "bullroarer",
  "button accordion",
  "buzuq",
  "byzaanchi",
  "c-bass recorder",
  "c-melody saxophone",
  "cabasa",
  "caixa",
  "caja",
  "caja vallenata",
  "cajas rumberas",
  "cajon",
  "cajon peruano",
  "calabash",
  "caller",
  "calliope",
  "calung",
  "campana",
  "cantor",
  "caramusa",
  "carillon",
  "carnyx",
  "castanets",
  "castrato",
  "cavaco",
  "cavaquinho",
  "caxixi",
  "celesta",
  "cello",
  "cello banjo",
  "cembalet",
  "ceng ceng",
  "cetara",
  "cevgen",
  "chacaras",
  "chacha",
  "chak'chas",
  "chakhe",
  "chalumeau",
  "chamber organ",
  "chamber pipes",
  "chamberlin",
  "chande",
  "changgo",
  "changi",
  "chansonnier",
  "chanter",
  "chanting",
  "chanzy",
  "chap",
  "chap lek",
  "chapman stick",
  "charamel",
  "charango",
  "chasquidos",
  "chau gong",
  "chekere",
  "cheng",
  "chikuzen biwa",
  "chime bar",
  "chimes",
  "chinchin",
  "chinese drum",
  "chinese flute",
  "chinese harp",
  "ching",
  "chirimia",
  "chirimia and drum",
  "chitarra battente",
  "chitarrone",
  "chitra veena",
  "chiwata",
  "chocalho",
  "choir",
  "choir member",
  "choir singing",
  "choir stand-in",
  "chonguri",
  "choral conductor",
  "chorus",
  "chromatic button accordion",
  "chromatic harmonica",
  "chuniri",
  "church organ",
  "chuurqin",
  "cifteli",
  "cigar box guitar",
  "cimbalom",
  "cimbasso",
  "cimpoi",
  "cinema organ",
  "cither",
  "citole",
  "cittern",
  "cizhonghu",
  "clapping",
  "clapstick",
  "clarin cajamarquino",
  "clarinet",
  "clarinet (c)",
  "clarinet (e flat)",
  "clarion",
  "clarsach",
  "classical guitar",
  "classical kemence",
  "claves",
  "clavichord",
  "clavier",
  "clavinet",
  "claviola",
  "clavioline",
  "claviorganum",
  "clog",
  "clog dancer",
  "co ke",
  "co-producer",
  "cobza",
  "colascione",
  "comb",
  "combolin",
  "comedian",
  "commentator",
  "computer",
  "concert band",
  "concert flute",
  "concert grand piano",
  "concert harp",
  "concertina",
  "concertmaster",
  "concertmistress",
  "conch shell",
  "concussion idiophone",
  "conductor",
  "conductor (instruments)",
  "conductor (strings)",
  "conductor (vocals)",
  "conga",
  "continuum",
  "contra-alto clarinet",
  "contrabass",
  "contrabass clarinet",
  "contrabass flute",
  "contrabass recorder",
  "contrabass saxophone",
  "contrabass trombone",
  "contrabass violin",
  "contrabassoon",
  "contralto",
  "contralto vocals",
  "contributor",
  "cornamuse",
  "cornet",
  "cornett",
  "corno da caccia",
  "coro",
  "counter tenor",
  "cowbells",
  "crash cymbals",
  "craviola",
  "cretan lyra",
  "cristal baschet",
  "cromorne",
  "crotales",
  "crumhorn",
  "crwth",
  "cuatro",
  "cuica",
  "cultrun",
  "cumbus",
  "cura",
  "curtal",
  "cyla-diare",
  "cylindrical drum",
  "cymbals",
  "daegeum",
  "daf",
  "daire",
  "daluo",
  "damaru",
  "dan bau",
  "dan nguyet",
  "dan nhi",
  "dan tam",
  "dan tam thap luc",
  "dan tranh",
  "dan tu",
  "dan tu day",
  "dan ty ba",
  "danburo",
  "dancer",
  "dancer saw",
  "danso",
  "darbuka",
  "daruan",
  "davul",
  "daw",
  "daxaphone",
  "deaejeng",
  "denis d'or",
  "dhol",
  "dholak",
  "di (flute)",
  "di (slit drum)",
  "diaff",
  "diatonic button accordion",
  "diddley bow",
  "didgeridoo",
  "digital audio workstation",
  "dikanza",
  "dilli tuiduk",
  "dilruba",
  "ding buot",
  "ding nam",
  "ding tac ta",
  "diple",
  "disk drive",
  "diyingehu",
  "dizi",
  "dj",
  "dj (scratcher)",
  "dj (spoken word)",
  "dj (toaster)",
  "djembe",
  "djoza",
  "djura",
  "dobro",
  "dobro-bass",
  "dohol",
  "doira",
  "dojo",
  "dolceola",
  "doli",
  "dombra",
  "domra",
  "doneli",
  "donno",
  "donso ngoni",
  "doorbell",
  "doshpuluur",
  "dotara",
  "double bass",
  "double bassoon",
  "double clarinet",
  "double flute",
  "double reed",
  "doumbaki",
  "doumbi",
  "doyra",
  "dramyin",
  "dril-bu",
  "droma",
  "drone",
  "drum",
  "drum kit",
  "drum machine",
  "drum major",
  "drum programming",
  "drum sergeant",
  "drumkit",
  "drums",
  "drums (drum set)",
  "duck call",
  "duduk",
  "duet with",
  "duff",
  "duggi",
  "dulce melos",
  "dulcian",
  "dulcimer",
  "dulcitone",
  "dulzaina",
  "dumbak",
  "dumbelek",
  "dumbuks",
  "dung-chen",
  "dunun",
  "dutar",
  "duxianqin",
  "dvojacka",
  "dvojnice",
  "e-bow",
  "e-flat clarinet",
  "ektara",
  "electric accordion",
  "electric appalachian dulcimer",
  "electric baritone guitar",
  "electric bass",
  "electric bass guitar",
  "electric cello",
  "electric drums",
  "electric fiddle",
  "electric fretless guitar",
  "electric grand piano",
  "electric guitar",
  "electric harmonium",
  "electric harp",
  "electric harpsichord",
  "electric keyboards",
  "electric lap steel guitar",
  "electric mandolin",
  "electric organ",
  "electric piano",
  "electric sitar",
  "electric upright bass",
  "electric viola",
  "electric violin",
  "electronic drum kit",
  "electronic drum set",
  "electronic instrument",
  "electronic music",
  "electronic percussion",
  "electronic valve instrument",
  "electronic vibraphone",
  "electronic wind instrument",
  "electronics",
  "electronium",
  "eligible studio producer",
  "emulator",
  "end-blown flute",
  "english bagpipes",
  "english concertina",
  "english flageolet",
  "english guitar",
  "english horn",
  "ensemble",
  "entertainer",
  "epinette des vosges",
  "erhu",
  "esraj",
  "euphonium",
  "ewi",
  "fado viola",
  "fairground organ",
  "falsetto",
  "falsetto vocals",
  "fanfare trumpet",
  "farfisa",
  "featuring",
  "feedback",
  "fiddle",
  "fife",
  "finger clicks",
  "finger cymbals",
  "finger snaps",
  "fipple flute",
  "flabiol",
  "flageolet",
  "flamenco guitar",
  "flauta",
  "flexatone",
  "floppy disk drive",
  "floyera",
  "flugabone",
  "flugelhorn",
  "fluier",
  "flumpet",
  "flute",
  "flute d'amour",
  "flute organ",
  "flutina",
  "folk guitar",
  "folk harp",
  "folklorist",
  "foot stamping",
  "foot stomps",
  "foot tapping",
  "footbass",
  "fortepiano",
  "fotdella",
  "frame drum",
  "free reed",
  "free-reed flute",
  "french bagpipes",
  "french horn",
  "fretless bass",
  "fretless bass guitar",
  "fretless guitar",
  "friction drum",
  "friction idiophone",
  "frigideira",
  "friscaletto",
  "frottoir",
  "frying-pan",
  "fujara",
  "fundeh",
  "fyell",
  "gadulka",
  "gaita",
  "gajde",
  "galician gaita",
  "gallichon",
  "galo",
  "galoubet",
  "gambang",
  "game console sound chip",
  "gamelan",
  "ganga",
  "gangsa",
  "gankogui",
  "ganza",
  "gaohu",
  "gardon",
  "garifuna drum",
  "garklein recorder",
  "garmon",
  "gayageum",
  "gbedu",
  "gehu",
  "gemshorn",
  "gender",
  "gender barung",
  "gender panerus",
  "gender wayang",
  "genggong",
  "geomungo",
  "german concertina",
  "german harp",
  "ghara",
  "ghatam",
  "ghati",
  "ghayta",
  "ghijak",
  "ghungroo",
  "giga",
  "gini",
  "gittern",
  "glass",
  "glass harmonica",
  "glass harp",
  "glockenspiel",
  "goblet drum",
  "goje",
  "gong",
  "gong bass drum",
  "gong chime",
  "gong-chime",
  "gorodao",
  "gottuvadyam",
  "gourd",
  "gourd rattle",
  "gralla",
  "gramorimba",
  "grand piano",
  "grantang",
  "gravikord",
  "great bass recorder",
  "great highland bagpipe",
  "griot",
  "grneta",
  "groovebox",
  "gu",
  "guacharaca",
  "guan",
  "guayo",
  "guban",
  "gubgubi",
  "gudastviri",
  "gudok",
  "gudugudu",
  "guest",
  "guimbri",
  "guira",
  "guiro",
  "guitalele",
  "guitar",
  "guitar banjo",
  "guitar synthesizer",
  "guitaret",
  "guitarra",
  "guitarron",
  "guitarron chileno",
  "guitarron mexicano",
  "guitarviol",
  "guitolao",
  "guitorgan",
  "guitsteel",
  "gung",
  "guntang",
  "guqin",
  "gusli",
  "guzheng",
  "haegeum",
  "halldorophone",
  "halszither",
  "hammer",
  "hammered dulcimer",
  "hammond organ",
  "hand bells",
  "hand clapping",
  "handpan",
  "hang drum",
  "hard disk drive",
  "hardanger fiddle",
  "hardingfele",
  "harjedalspipa",
  "harmet",
  "harmonica",
  "harmonium",
  "harmony vocals",
  "harp",
  "harp guitar",
  "harpejji",
  "harpsichord",
  "harpsipiano",
  "haute-contre",
  "haute-contre vocals",
  "hawaiian guitar",
  "heckelphone",
  "heike biwa",
  "helicon",
  "hi-hat",
  "hichiriki",
  "high violin",
  "highland bagpipes",
  "hmong flute",
  "hoddu",
  "homus",
  "horagai",
  "horns",
  "hosho",
  "hot fountain pen",
  "hotchiku",
  "hourglass drum",
  "huapanguera",
  "hudukka",
  "hue puruhau",
  "hue puruwai",
  "hulusi",
  "hummel",
  "humming",
  "hunting horn",
  "hunting horn (valved)",
  "huqin",
  "hurdy-gurdy",
  "hyoshigi",
  "ichigenkin",
  "idiophone",
  "igil",
  "imitation bass",
  "impersonator",
  "indian harp",
  "indonesian rebab",
  "instructor",
  "instrument",
  "instruments",
  "interview",
  "interviewee",
  "interviewer",
  "irish bouzouki",
  "irish flute",
  "irish harp",
  "irish whistle",
  "jagd horn",
  "jaggo",
  "jal tarang",
  "janggu",
  "jantar",
  "japanese wooden flute",
  "jarana",
  "jazz horn",
  "jegogan",
  "jejo",
  "jejo voatavo",
  "jeli ngoni",
  "jew's harp",
  "jing",
  "jing'erhu",
  "jinghu",
  "jingle bells",
  "joik",
  "jouhikko",
  "jublag",
  "jug",
  "jugkalimba",
  "jumbush",
  "junjung",
  "jushichigen-kin (bass koto)",
  "ka (drum)",
  "kaba gaida",
  "kabosy",
  "kacapi",
  "kacapi indung",
  "kacapi rincik",
  "kacapi siter",
  "kachva sitar",
  "kagura suzu",
  "kagurabue",
  "kaiamba rambo",
  "kakegoe",
  "kalimba",
  "kamac",
  "kamaica",
  "kamale ngoni",
  "kamancheh",
  "kanjira",
  "kankles",
  "kannel",
  "kantele",
  "kantilan",
  "kanun",
  "karamouza",
  "karigo",
  "karkabas",
  "karna",
  "kaval",
  "kayagum",
  "kazoo",
  "kecer",
  "kemanak",
  "kemence",
  "kemence of the black sea",
  "kempli",
  "kempul",
  "kempyang",
  "ken bau",
  "ken la",
  "kena",
  "kendang",
  "kendang lanang",
  "kendang wadon",
  "kendhang batangan",
  "kendhang gendhing",
  "kendhang indung",
  "kendhang ketipung",
  "kendhang kulanter",
  "kendhang wayangan",
  "kenong",
  "kepyak",
  "kethuk",
  "kettledrum",
  "ketuk",
  "keyboard bass",
  "keyboards",
  "keyed box zither",
  "keyed brass instruments",
  "keytar",
  "khaen",
  "khalam",
  "khartal",
  "khen meo",
  "khene",
  "khim",
  "khlui",
  "khol",
  "khong wong",
  "khong wong lek",
  "khong wong yai",
  "khulsan khuur",
  "khurdak",
  "khuur",
  "ki pah",
  "kinnor",
  "kirar",
  "kithara",
  "kkwaenggwari",
  "klong",
  "klong khaek",
  "klong song na",
  "klong that",
  "klong yao",
  "koauau",
  "koauau ponga ihu",
  "kobyz",
  "kokle",
  "kokyu",
  "komun'go",
  "komuz",
  "kora",
  "kortholt",
  "kos",
  "koto",
  "kotsuzumi",
  "krakebs",
  "krap",
  "krap khu",
  "krap phuang",
  "krap sepha",
  "krar",
  "kudum",
  "kulintang",
  "kusle",
  "kynggari",
  "lagerphone",
  "lakota flute",
  "lamba",
  "lamellophone",
  "langeleik",
  "laouto",
  "lap harp",
  "lap steel guitar",
  "laser harp",
  "laud",
  "launeddas",
  "lautenwerck",
  "lavta",
  "lead guitar",
  "lead vocals",
  "leader",
  "likembe",
  "lilting",
  "limbe",
  "lion's roar",
  "lira",
  "lira da braccio",
  "lira organizzatai",
  "lirica",
  "lirone",
  "liru",
  "lithophone",
  "liuqin",
  "llaute",
  "log drum",
  "lokanga bara",
  "lokole",
  "low whistle",
  "lowland pipes",
  "lukeme",
  "lur",
  "lute",
  "lute guitar",
  "lute-harpsichord",
  "lutheal",
  "lyra",
  "lyra viol",
  "lyre",
  "lyricon",
  "lysarden",
  "madal",
  "maddalam",
  "maddale",
  "magruna",
  "mallets",
  "mandobass",
  "mandocello",
  "mandoguitar",
  "mandola",
  "mandolin",
  "mandolin banjo",
  "mandolin family",
  "mandolincello",
  "mandolute",
  "mandore",
  "manjira",
  "mankeri",
  "manzello",
  "maracas",
  "marimba",
  "marimba lumina",
  "marimbula",
  "marine trumpet",
  "mark tree",
  "marovany",
  "marxophone",
  "masenqo",
  "master of ceremonies (mc)",
  "mbira",
  "mechanical general",
  "mejoranera",
  "mellophone",
  "mellophonium",
  "mellotron",
  "melodeon",
  "melodica",
  "membranophone",
  "mendoza",
  "metallophone",
  "mexican vihuela",
  "mey",
  "mezzo violin",
  "mezzo-contralto",
  "mezzo-soprano",
  "midi",
  "midi controller",
  "midistick",
  "mijwiz",
  "minimoog",
  "minipiano",
  "minister",
  "mirliton",
  "mirwas",
  "miscellaneous",
  "mizmar",
  "mizwad",
  "moceno",
  "mong",
  "monkey stick",
  "monochord",
  "moog",
  "morchang",
  "morin khuur",
  "morrisette",
  "morsing",
  "mountain dulcimer",
  "mouth bow",
  "mouth harp",
  "mouth music",
  "mouth organ",
  "mrdanga",
  "mukkuri",
  "munnharpe",
  "murali",
  "murcang",
  "murli",
  "muselar",
  "musette",
  "musette de cour",
  "music box",
  "music director",
  "music sequencer",
  "music video clip director",
  "musical bow",
  "musical saw",
  "musician",
  "n'vike",
  "nabal",
  "nadaswaram",
  "nagadou-daiko",
  "nagak",
  "nai",
  "nakers",
  "nal",
  "nanga",
  "naobo",
  "naqqara",
  "narrator",
  "nattuva talam",
  "natural brass instruments",
  "natural horn",
  "natural trumpet",
  "ney",
  "ngoma",
  "ngoni",
  "nguru",
  "nigenkin",
  "njarka",
  "nkoni",
  "nohkan",
  "noises",
  "northumbrian pipes",
  "northumbrian small pipes",
  "nose flute",
  "nose whistle",
  "novachord",
  "nyatiti",
  "nyckelharpa",
  "oboe",
  "oboe d'amore",
  "oboe da caccia",
  "ocarina",
  "ocean drum",
  "octapad",
  "octave mandolin",
  "octavilla",
  "octavina",
  "octoban",
  "octobass",
  "okonkole",
  "oktawka",
  "olifant",
  "omnichord",
  "ondes martenot",
  "ondioline",
  "one-man band",
  "onoben",
  "open-back banjo",
  "ophicleide",
  "optigan",
  "organ",
  "organistrum",
  "orpharion",
  "orphica",
  "otamatone",
  "other",
  "other brass instruments",
  "other instruments",
  "other plucking instruments",
  "other woodwind instruments",
  "otsuzumi",
  "oud",
  "outi",
  "oval spinet",
  "overtone flute",
  "overtone voice",
  "p'iri",
  "pahu",
  "pahu pounamu",
  "paiban",
  "paila",
  "pakhavaj",
  "pakuru",
  "palmas",
  "pan flute",
  "pandeiro",
  "pandereta",
  "panduri",
  "pang gu ly hu hmong",
  "pano",
  "panpipes",
  "paraguayan harp",
  "pardessus de viole",
  "parlour grand piano",
  "pate",
  "pedabro",
  "pedal accordion",
  "pedal piano",
  "pedal steel guitar",
  "pedalboard",
  "pemade",
  "percussion",
  "percussion idiophone",
  "performer",
  "phach",
  "pi",
  "pi chawa",
  "pi nai",
  "pi thiu",
  "pianet",
  "piano",
  "piano accordion",
  "piano duo",
  "piano four hands",
  "piano quartet",
  "piano spinet",
  "piano trio",
  "pianoforte",
  "piccolo",
  "piccolo banjo",
  "piccolo bass",
  "piccolo bass guitar",
  "piccolo flute",
  "piccolo oboe",
  "piccolo trumpet",
  "pierrot ensemble",
  "pifana",
  "piffaro",
  "pipa",
  "pipe and tabor",
  "pipe major",
  "pipe organ",
  "pipe sergeant",
  "pipes",
  "pirula",
  "pito",
  "pito herreno",
  "pixiephone",
  "pkhachich",
  "platillos",
  "player piano",
  "plectrum banjo",
  "plucked idiophone",
  "plucked string instruments",
  "pluriarc",
  "pocket trumpet",
  "poetry reader",
  "poi",
  "poi awhiowhio",
  "polyphon",
  "porotiti",
  "portative",
  "portuguese guitar",
  "porutu",
  "positive organ",
  "post horn",
  "practice chanter",
  "preacher",
  "prempensua",
  "prepared piano",
  "presenter",
  "primero",
  "producer",
  "producer (rhythm track)",
  "producer (vocal)",
  "producer remixer",
  "producer vocal",
  "programming",
  "psalmodicon",
  "psaltery",
  "pujador",
  "pukaea",
  "pullankulal",
  "pumotomoto",
  "pump organ",
  "pupakapaka",
  "purerehua",
  "putatara",
  "putorino",
  "qanun",
  "qasaba",
  "qilaut",
  "qirba",
  "quadruple reed",
  "quart-bassoon",
  "quena",
  "quenacho",
  "quijada",
  "quills",
  "quint-bassoon",
  "quinto",
  "quinton",
  "quray",
  "rababa",
  "rabeca",
  "rabel",
  "rackett",
  "raconteur",
  "rag dung",
  "rainstick",
  "rammana",
  "ranat ek",
  "ranat kaeo",
  "ranat thum",
  "rap",
  "ratchet",
  "rattle",
  "rauschpfeife",
  "ravanahatha",
  "reactable",
  "read by",
  "rebab",
  "rebec",
  "reciter",
  "reco-reco",
  "recorder",
  "reed organ",
  "reeds",
  "regal",
  "rehu",
  "reikin",
  "remaster producer",
  "remix engineer",
  "renaissance rackett",
  "repeater",
  "repinique",
  "repique",
  "reporter",
  "requinto",
  "requinto guitar",
  "resonator",
  "resonator banjo",
  "resonator guitar",
  "reyong",
  "rgya-gling",
  "rhaita",
  "rhodes piano",
  "rhythm guitar",
  "rhythm section",
  "rhythm sticks",
  "rhythms box",
  "riqq",
  "rkang-gling",
  "rnga",
  "rol-mo",
  "rondador",
  "ronroco",
  "roria",
  "rototoms",
  "rozhok",
  "ruan",
  "rubab",
  "rubboard",
  "rudra veena",
  "ryuteki",
  "sabar",
  "sackbut",
  "sackpipa",
  "saduk",
  "saenghwang",
  "salamuri",
  "salterio",
  "saluang",
  "samba whistle",
  "samica",
  "sampler",
  "sampona",
  "samvadini",
  "sanfona",
  "sanger-in",
  "sanshin",
  "santoor",
  "sanxian",
  "sanza",
  "sao meo",
  "sao truc",
  "sapeh",
  "sarangi",
  "saraswati veena",
  "sargija",
  "sarod",
  "saron",
  "saron barung",
  "saron demung",
  "saron family",
  "saron panerus",
  "saron peking",
  "saron wayang",
  "saroz",
  "sarrusophone",
  "satara",
  "satsuma",
  "satsuma biwa",
  "saw",
  "saw duang",
  "saw sam sai",
  "saw u",
  "saxello",
  "saxhorn",
  "saxophone",
  "saxophone quartet",
  "saxor",
  "saz",
  "scat",
  "schlagzeug drums",
  "schwyzerorgeli",
  "scottish small pipes",
  "scottish smallpipes",
  "scraped idiophone",
  "scraper",
  "scratcher",
  "scratches",
  "segunda",
  "selmer-maccaferri guitar",
  "semi-acoustic guitar",
  "senh tien",
  "seni rebab",
  "seperewa",
  "sequencer",
  "serpent",
  "setar",
  "shahi baaja",
  "shakers",
  "shakubyoshi",
  "shakuhachi",
  "shamisen",
  "shawm",
  "shehnai",
  "shekere",
  "sheng",
  "shichepshin",
  "shime-daiko",
  "shinobue",
  "sho",
  "shofar",
  "shouting",
  "shruti box",
  "shudraga",
  "shuitar",
  "shuttle pipes",
  "siku",
  "sil-snyan",
  "sindhi sarangi",
  "singer",
  "singing bowls",
  "single reed",
  "sintir",
  "siren",
  "sistrum",
  "sitar",
  "skratjie",
  "slagbordun",
  "slapstick",
  "sleigh bells",
  "slenthem",
  "slide brass instruments",
  "slide guitar",
  "slide trumpet",
  "slide whistle",
  "slit drums",
  "small bass violin",
  "small guitar",
  "smallpipes",
  "snare",
  "snare drums",
  "sodina",
  "software instrument",
  "solo vocal",
  "soloist",
  "song loan",
  "sopilka",
  "sopranino",
  "sopranino clarinet",
  "sopranino recorder",
  "sopranino saxophone",
  "soprano",
  "soprano clarinet",
  "soprano cornet",
  "soprano crumhorn",
  "soprano flute",
  "soprano recorder",
  "soprano saxophone",
  "soprano trombone",
  "soprano violin",
  "soprano vocals",
  "sordone",
  "sorna",
  "souna",
  "sound effects",
  "sounds",
  "sousaphone",
  "souvliari",
  "spanish guitar",
  "speech",
  "spike-fiddle",
  "spilapipa",
  "spinet",
  "spinettone",
  "spoken word",
  "spoons",
  "square pianoforte",
  "steam locomotive sounds",
  "steel drums",
  "steel guitar",
  "steel-string acoustic guitar",
  "steelpan",
  "steirische harmonika",
  "step dancer",
  "stick sal",
  "stick zither",
  "stomp box",
  "storyteller",
  "street organ",
  "string drum",
  "string quartet",
  "string quintet",
  "string synthesizer",
  "string trio",
  "strings",
  "stritch",
  "stroh violin",
  "strohfidel",
  "struck idiophone",
  "struck string instruments",
  "strumstick",
  "studio conductor",
  "studio personnel (performing)",
  "stylophone",
  "subcontrabass recorder",
  "subcontrabass saxophone",
  "suka",
  "suling",
  "suona",
  "surbahar",
  "surdo",
  "surigane",
  "surmandal",
  "surnai (kashmir)",
  "sursingar",
  "svara mandala",
  "svirala",
  "swanee whistle",
  "swarmandal",
  "symphony",
  "sympitar",
  "synclavier",
  "synthaxe",
  "synthesizer",
  "syrinx",
  "t'rung",
  "taal",
  "tabal",
  "tabla",
  "table steel guitar",
  "tabor",
  "tack piano",
  "taegum",
  "taepyeongso",
  "taiko",
  "taishogoto",
  "talharpa",
  "talkbox",
  "talking drum",
  "tam-tam",
  "tama",
  "tambin",
  "tambora",
  "tamboril",
  "tamborim",
  "tambourine",
  "tambur (drum)",
  "tambur (gong)",
  "tambur (lute)",
  "tambura",
  "tamburica",
  "tan-tan",
  "tanbou ka",
  "tanbur",
  "tangent piano",
  "tannerin",
  "tanpura",
  "taonga puoro",
  "tap dancer",
  "tapan",
  "tapboard",
  "taphon",
  "tar",
  "tar (drum)",
  "tar (flute)",
  "tar (frame drum)",
  "tar (lute)",
  "tar shenai",
  "taragot",
  "taragoto",
  "tarawangsa",
  "tarka",
  "tarogato",
  "tarol",
  "tarota",
  "tavil",
  "te ku",
  "tea chest bass",
  "tef",
  "telharmonium",
  "temple bells",
  "temple blocks",
  "temur khuur",
  "tenor",
  "tenor banjo",
  "tenor bassoon",
  "tenor flute",
  "tenor guitar",
  "tenor horn",
  "tenor recorder",
  "tenor sarrusophone",
  "tenor saxophone",
  "tenor sordun",
  "tenor trombone",
  "tenor viol",
  "tenor violin",
  "tenor vocals",
  "tenora",
  "tenoroon",
  "tepsija",
  "thavil",
  "the great stalacpipe organ",
  "theatre organ",
  "theorbo",
  "theremin",
  "thon",
  "three-hole pipe",
  "throat singing",
  "thumb piano",
  "ti bwa",
  "ti-tse",
  "tibetan singing bowl",
  "tibetan water drum",
  "tible",
  "tieu",
  "tifa",
  "timbal",
  "timbrel",
  "timpani",
  "timple",
  "tin whistle",
  "tinya",
  "tiompan",
  "tiple",
  "toasting",
  "tokere",
  "tololoche",
  "tom-tom",
  "tombak",
  "tonette",
  "tongatong",
  "tonkori",
  "topshuur",
  "torader",
  "totobuang",
  "toumbas",
  "tovshuur",
  "toy (instruments)",
  "toy piano",
  "traditional basque ensemble",
  "tram ple",
  "trang jau",
  "trang lu",
  "transverse flute",
  "traps",
  "trautonium",
  "treble",
  "treble flute",
  "treble recorder",
  "treble shawm",
  "treble tambura",
  "treble viol",
  "treble violin",
  "treble vocals",
  "tres",
  "tres cubano",
  "triangle",
  "trikitixa",
  "triple harp",
  "tritantri veena",
  "tromba marina",
  "trombone",
  "trompeta",
  "trompetica china",
  "trong bong",
  "trumpet",
  "trumpet (eflat)",
  "trumpet marine",
  "trutruka",
  "tsuur",
  "tuba",
  "tubaphone",
  "tubax",
  "tube zither",
  "tubon",
  "tubular bells",
  "tubulum",
  "tulum",
  "tumba",
  "tumba (goblet drum)",
  "tumbadora",
  "tumbi",
  "tumutumu",
  "tun",
  "tuned percussion",
  "tungso",
  "tungur",
  "tusseflute",
  "txalaparta",
  "txirula",
  "txistu",
  "tymps",
  "typewriter",
  "tzouras",
  "udu",
  "ugal",
  "uilleann pipes",
  "ukeke",
  "ukulele",
  "ukulele banjo",
  "untuned percussion",
  "upright piano",
  "utogardon",
  "valiha",
  "valve trombone",
  "valve trumpet",
  "valved brass instruments",
  "variophon",
  "veena",
  "venu",
  "vessel flute",
  "vibes",
  "vibra-slap",
  "vibrandoneon",
  "vibraphone",
  "vichitra veena",
  "vielle",
  "vietnamese guitar",
  "vihuela",
  "viol",
  "viol consort",
  "viol family",
  "viola",
  "viola (guitar)",
  "viola bastarda",
  "viola beiroa",
  "viola braguesa",
  "viola caipira",
  "viola campanica",
  "viola d'amore",
  "viola da gamba",
  "viola de cocho",
  "viola kontra",
  "viola nordestina",
  "viola organista",
  "viola pomposa",
  "violarina",
  "violin",
  "violin octet",
  "violino piccolo",
  "viololyra",
  "violoncello",
  "violoncello piccolo",
  "violone",
  "violotta",
  "virginals",
  "vocal effects",
  "vocal percussion",
  "vocalese",
  "vocalizer",
  "vocals",
  "vocoder",
  "voice",
  "voice actor",
  "voice synthesizer",
  "vuvuzela",
  "wagner tuba",
  "walaycho",
  "waldhorn",
  "warr guitar",
  "washboard",
  "washint",
  "washtub bass",
  "waterphone",
  "wavedrum",
  "weisenborn",
  "whip",
  "whistle",
  "whistling",
  "whistling water jar",
  "wiener horn",
  "willow flute",
  "wind",
  "wind chime",
  "wind machine",
  "wind piano",
  "wind synthesizer",
  "wire-strung harp",
  "wobble board",
  "wood block",
  "wood chimes",
  "woodblock",
  "wooden fish",
  "wooden flute",
  "woodwind",
  "word director",
  "worship leader",
  "wot",
  "wurlitzer electric piano",
  "wurlitzer organ",
  "xalam",
  "xaphoon",
  "xiao",
  "xiaoluo",
  "xun",
  "xylophone",
  "xylophone (strohfidel)",
  "xylorimba",
  "yaktaro",
  "yamaha wx-7",
  "yanggeum",
  "yangqin",
  "yatga",
  "yayli tanbur",
  "yehu",
  "yenjing",
  "yodelling",
  "yonggo",
  "yoochin",
  "yorgaphone",
  "yueqin",
  "yunluo",
  "zabumba",
  "zafzafa",
  "zampogna",
  "zamr",
  "zapateado",
  "zaqq",
  "zarb",
  "zeze",
  "zhaleika",
  "zhonghu",
  "zhongruan",
  "zhuihu",
  "zill",
  "zirbaghali",
  "zither",
  "zongora",
  "zukra",
  "zummara",
  "zurna",
];

/** Top-level parent roles only (the standardised role names). */
export const parentContributionRoles: string[] = [
  "12-string guitar",
  "accompanist",
  "accordion",
  "achere",
  "acoustic bass",
  "acoustic guitar",
  "akete",
  "alghoza",
  "alphorn",
  "alto saxophone",
  "aman khuur",
  "analog synthesizer",
  "angklung",
  "appalachian dulcimer",
  "archlute",
  "arrabel",
  "artistic narrator",
  "ashiko",
  "autoharp",
  "backing vocals",
  "baglama (saz) family",
  "bagpipes",
  "baltic psalteries",
  "band",
  "bandoneon",
  "bandora",
  "banjo",
  "banjo guitar",
  "banjo-ukulele",
  "bansuri",
  "barbat",
  "baritone",
  "baritone guitar",
  "baritone saxophone",
  "baroque guitar",
  "barrel drum",
  "barrel organ",
  "bass",
  "bass drum",
  "bass recorder",
  "bass viol",
  "bass violin",
  "bass-baritone",
  "bassoon",
  "bata drum",
  "bell-piano",
  "bellow-blown bagpipes",
  "bellowed reed",
  "bells",
  "bin",
  "bin-sitar",
  "biwa",
  "body percussion",
  "bombo",
  "bonang",
  "bonang barung",
  "bonang panembung",
  "bongos",
  "boobam",
  "border pipes",
  "bouzouki",
  "bowed lute",
  "bowed lyre",
  "bowed psaltery",
  "bowed string instruments",
  "box zither",
  "brass",
  "bronze lur",
  "bugle",
  "button accordion",
  "c-melody saxophone",
  "cabasa",
  "caixa",
  "caja",
  "cajon",
  "castanets",
  "castrato",
  "cavaquinho",
  "celesta",
  "cello",
  "chakhe",
  "chamber organ",
  "chamberlin",
  "chanting",
  "chap",
  "chapman stick",
  "chimes",
  "chirimia",
  "chorus",
  "chromatic button accordion",
  "chuurqin",
  "cither",
  "cittern",
  "clapstick",
  "clarinet",
  "classical guitar",
  "clavichord",
  "claviorganum",
  "clog",
  "concert flute",
  "concert harp",
  "concertina",
  "concussion idiophone",
  "conductor",
  "contrabass saxophone",
  "contralto",
  "cornet",
  "cornett",
  "crumhorn",
  "cumbus",
  "cylindrical drum",
  "cymbals",
  "daf",
  "dan bau",
  "dan nhi",
  "dancer",
  "darbuka",
  "davul",
  "diatonic button accordion",
  "didgeridoo",
  "digital audio workstation",
  "dilli tuiduk",
  "dilruba",
  "disk drive",
  "dobro",
  "dohol",
  "dolceola",
  "double bass",
  "double flute",
  "double reed",
  "drum machine",
  "drum programming",
  "drums",
  "drums (drum set)",
  "dulce melos",
  "dulcian",
  "dulcimer",
  "dunun",
  "e-flat clarinet",
  "ektara",
  "electric bass guitar",
  "electric cello",
  "electric fretless guitar",
  "electric guitar",
  "electric keyboards",
  "electric piano",
  "electric viola",
  "electric violin",
  "electronic drum set",
  "electronic instrument",
  "electronic wind instrument",
  "eligible studio producer",
  "end-blown flute",
  "euphonium",
  "falsetto",
  "fiddle",
  "fife",
  "finger cymbals",
  "finger snaps",
  "fipple flute",
  "flabiol",
  "flageolet",
  "flamenco guitar",
  "flugelhorn",
  "flumpet",
  "flute",
  "folk harp",
  "foot stomps",
  "frame drum",
  "free reed",
  "fretless bass",
  "friction drum",
  "friction idiophone",
  "frottoir",
  "frying-pan",
  "galo",
  "gamelan",
  "garifuna drum",
  "gayageum",
  "gender",
  "german concertina",
  "ghara",
  "glass",
  "glass harp",
  "goblet drum",
  "gong",
  "gong-chime",
  "gourd",
  "gralla",
  "grand piano",
  "great highland bagpipe",
  "guan",
  "guban",
  "gudok",
  "guitar",
  "guitaret",
  "guitarron chileno",
  "guqin",
  "gusli",
  "guzheng",
  "haegeum",
  "hammered dulcimer",
  "hammond organ",
  "hand clapping",
  "harmonica",
  "harmonium",
  "harp",
  "harpsichord",
  "haute-contre",
  "hawaiian guitar",
  "helicon",
  "hi-hat",
  "hmong flute",
  "hourglass drum",
  "hunting horn (valved)",
  "huqin",
  "hurdy-gurdy",
  "idiophone",
  "interview",
  "jing",
  "jug",
  "kaba gaida",
  "kacapi",
  "kachva sitar",
  "kamancheh",
  "kannel",
  "karamouza",
  "kaval",
  "kempul",
  "kendang",
  "keyboards",
  "keyed box zither",
  "khol",
  "khong wong",
  "khong wong yai",
  "kkwaenggwari",
  "klong that",
  "kora",
  "koto",
  "krap",
  "lamellophone",
  "lap steel guitar",
  "lira da braccio",
  "lirone",
  "lithophone",
  "lukeme",
  "lute",
  "lute-harpsichord",
  "lyra viol",
  "lyre",
  "madal",
  "mandola",
  "mandolin",
  "mandolin family",
  "maracas",
  "marimba",
  "mbira",
  "melodica",
  "membranophone",
  "mendoza",
  "metallophone",
  "mezzo-contralto",
  "mirliton",
  "miscellaneous",
  "monkey stick",
  "monochord",
  "morin khuur",
  "morsing",
  "mouth harp",
  "mouth organ",
  "murali",
  "musette de cour",
  "musical bow",
  "nanga",
  "naqqara",
  "narrator",
  "natural brass instruments",
  "natural horn",
  "natural trumpet",
  "ngoni",
  "northumbrian pipes",
  "nose flute",
  "nyatiti",
  "nyckelharpa",
  "oboe",
  "oboe da caccia",
  "octavilla",
  "octoban",
  "organ",
  "other instruments",
  "other woodwind instruments",
  "pahu",
  "pan flute",
  "pardessus de viole",
  "pedal steel guitar",
  "percussion",
  "percussion idiophone",
  "performer",
  "pi",
  "pianet",
  "piano",
  "piano accordion",
  "pianoforte",
  "piccolo",
  "piccolo oboe",
  "pipa",
  "pipe and tabor",
  "pipe organ",
  "plucked idiophone",
  "plucked string instruments",
  "pluriarc",
  "portuguese guitar",
  "post horn",
  "producer",
  "producer (vocal)",
  "programming",
  "psaltery",
  "pump organ",
  "putatara",
  "qilaut",
  "quadruple reed",
  "quena",
  "quinto",
  "rababa",
  "rackett",
  "rainstick",
  "ranat ek",
  "rattle",
  "ravanahatha",
  "rebab",
  "reco-reco",
  "recorder",
  "reeds",
  "regal",
  "repinique",
  "resonator guitar",
  "rhythm sticks",
  "rondador",
  "ruan",
  "rudra veena",
  "sabar",
  "saduk",
  "samica",
  "sanshin",
  "sanxian",
  "sarangi",
  "sargija",
  "saron",
  "saron family",
  "sarrusophone",
  "satsuma biwa",
  "saw duang",
  "saw u",
  "saxophone",
  "saz",
  "scottish smallpipes",
  "scraped idiophone",
  "scratcher",
  "shakers",
  "shakuhachi",
  "shawm",
  "shekere",
  "siku",
  "singer",
  "single reed",
  "sitar",
  "slenthem",
  "slide brass instruments",
  "sopilka",
  "sopranino recorder",
  "sopranino saxophone",
  "soprano",
  "soprano saxophone",
  "sorna",
  "sound effects",
  "sounds",
  "souvliari",
  "spike-fiddle",
  "spilapipa",
  "spinet",
  "steel drums",
  "steel guitar",
  "steel-string acoustic guitar",
  "stick zither",
  "storyteller",
  "string drum",
  "string quartet",
  "string quintet",
  "strings",
  "struck idiophone",
  "struck string instruments",
  "surdo",
  "sursingar",
  "swarmandal",
  "synthesizer",
  "tack piano",
  "taepyeongso",
  "taiko",
  "taishogoto",
  "talharpa",
  "tamborim",
  "tambourine",
  "tambura",
  "tamburica",
  "tanbur",
  "taonga puoro",
  "tar",
  "tar (frame drum)",
  "tarota",
  "tef",
  "temple blocks",
  "tenor",
  "tenora",
  "tenoroon",
  "thavil",
  "theatre organ",
  "three-hole pipe",
  "tibetan water drum",
  "tifa",
  "timple",
  "tin whistle",
  "tiple",
  "tom-tom",
  "topshuur",
  "toumbas",
  "toy piano",
  "trang lu",
  "treble",
  "tres",
  "tromba marina",
  "trombone",
  "trumpet",
  "tuba",
  "tube zither",
  "tumba (goblet drum)",
  "tuned percussion",
  "tungso",
  "uilleann pipes",
  "ukulele",
  "utogardon",
  "valve trombone",
  "valved brass instruments",
  "veena",
  "vessel flute",
  "vibraphone",
  "vichitra veena",
  "vielle",
  "viol",
  "viol family",
  "viola",
  "viola da gamba",
  "violin",
  "violin octet",
  "viololyra",
  "vocals",
  "voice",
  "walaycho",
  "washboard",
  "whistle",
  "wind",
  "wind chime",
  "wind synthesizer",
  "wood block",
  "woodwind",
  "worship leader",
  "xalam",
  "xiao",
  "xiaoluo",
  "xylophone",
  "xylophone (strohfidel)",
  "yangqin",
  "yatga",
  "zarb",
  "zhuihu",
  "zirbaghali",
  "zither",
  "zummara",
];
